import { IterableListItem } from "../../../utils/IterableItemFactory";
import { UserActivationAction } from "../ActivationAction";
import {
  ContainsCondition, EndsWithCondition,
  EqualsCondition, StartsWithCondition, WordEqualsCondition
} from "./conditions";

export type AutoReplyActions = Array<AutoReplyAction>

export type AutoReplyAction = {
  conditions: Array<Array<AutoReplyConditions>>
  action: UserActivationAction
  guid: string
}

export type LocalAutoReplyAction = Pick<AutoReplyAction, 'guid' | 'action'> & {
  conditions: Array<IterableListItem<Array<IterableListItem<AutoReplyConditions>>>>
}

export enum AutoReplyConditionTypeEnum {
  Equals = 'Equals',
  Contains = 'Contains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  WordEquals = 'WordEquals',
}

export type AutoReplyConditions =
  EqualsCondition
  | ContainsCondition
  | StartsWithCondition
  | EndsWithCondition
  | WordEqualsCondition

export type AutoReplyConditionBaseFields = {
  values: Array<string>
  invert: boolean
}
